/**
 * Utilidades para el manejo de fechas en el frontend
 */

/**
 * Convierte una fecha a formato datetime-local para inputs HTML
 * Usa la zona horaria local del navegador para evitar desfases
 * @param {string|Date} fecha - Fecha a convertir
 * @returns {string} Fecha en formato YYYY-MM-DDTHH:mm
 */
export const formatearFechaParaInput = (fecha) => {
  if (!fecha) return ''
  
  const date = new Date(fecha)
  
  // Verificar que la fecha sea válida
  if (isNaN(date.getTime())) {
    console.warn('Fecha inválida:', fecha)
    return ''
  }
  
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  
  return `${year}-${month}-${day}T${hours}:${minutes}`
}

/**
 * Convierte una fecha a formato legible para mostrar en la interfaz
 * @param {string|Date} fecha - Fecha a convertir
 * @returns {string} Fecha formateada
 */
export const formatearFechaParaMostrar = (fecha) => {
  if (!fecha) return '-'
  
  const date = new Date(fecha)
  
  // Verificar que la fecha sea válida
  if (isNaN(date.getTime())) {
    console.warn('Fecha inválida:', fecha)
    return '-'
  }
  
  return date.toLocaleString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
}

/**
 * Obtiene la fecha actual en formato datetime-local
 * @returns {string} Fecha actual en formato YYYY-MM-DDTHH:mm
 */
export const obtenerFechaActual = () => {
  const now = new Date()
  return formatearFechaParaInput(now)
}

/**
 * Convierte una fecha de formato datetime-local a objeto Date
 * @param {string} fechaString - Fecha en formato YYYY-MM-DDTHH:mm
 * @returns {Date} Objeto Date
 */
export const parsearFechaDesdeInput = (fechaString) => {
  if (!fechaString) return null
  
  const date = new Date(fechaString)
  
  // Verificar que la fecha sea válida
  if (isNaN(date.getTime())) {
    console.warn('Fecha inválida:', fechaString)
    return null
  }
  
  return date
} 